"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingSubscriptionStatusEnum = void 0;
var BillingSubscriptionStatusEnum;
(function (BillingSubscriptionStatusEnum) {
  /** настраивается */
  BillingSubscriptionStatusEnum[BillingSubscriptionStatusEnum["pending"] = 0] = "pending";
  /** действует */
  BillingSubscriptionStatusEnum[BillingSubscriptionStatusEnum["active"] = 1] = "active";
  /** отменена */
  BillingSubscriptionStatusEnum[BillingSubscriptionStatusEnum["canceled"] = 2] = "canceled";
  /** устарела */
  BillingSubscriptionStatusEnum[BillingSubscriptionStatusEnum["expired"] = 3] = "expired";
  /** не активный */
  BillingSubscriptionStatusEnum[BillingSubscriptionStatusEnum["not_active"] = 4] = "not_active";
})(BillingSubscriptionStatusEnum = exports.BillingSubscriptionStatusEnum || (exports.BillingSubscriptionStatusEnum = {}));
